// Regex to filter invalid keywords
export const keywordRegex = /^\s*(?:[^\w\s]|_)(?:\s*(?:[^\w\s]|_))*\s*$/;

// Helper function to validate keyword
export const isValidKeyword = (keyword: string): boolean => {
  const trimmed = keyword.trim();
  return trimmed.length > 0 && !keywordRegex.test(trimmed);
};

// Helper function to fix quotes - only fix unmatched quotes at start/end, preserve middle quotes
export const fixSingleQuotes = (text: string): string => {
  let result = text;

  // Check if string starts and ends with quotes
  const startsWithQuote = result.startsWith('"') || result.startsWith("'") || result.startsWith('`');
  const endsWithQuote = result.endsWith('"') || result.endsWith("'") || result.endsWith('`');

  // Only fix unmatched quotes at start/end
  if (startsWithQuote && !endsWithQuote) {
    // Add closing quote
    result += '"';
  } else if (!startsWithQuote && endsWithQuote) {
    // Add opening quote
    result = '"' + result;
  }

  return result;
};

export const processCommaSeparatedValues = (text: string): string[] => {
  return text
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0)
    .map((item) => fixSingleQuotes(item))
    .filter((item) => isValidKeyword(item));
};
